export default {
  getOperadorFilaById: state => id => {
    return state.dadosOperador.find(element => element.operador === id)
  },
  getDadosRelatorioOperadorIndividual: state => state.dadoRelatorioOperadorIndividual,
}
